import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getWorkspaces } from 'Screens/Contextualization/Workspaces/actions/Actions';
import { MODAL_APPLY_TEMPLATE, MODAL_EVIDENCE_WARNING_UPLOAD } from 'store/modals/modals';
import selectModal from 'store/modals/selectors';
import ApplyTemplateModal from 'Screens/Contextualization/KnowledgeBase/components/EditVuln';
import { bulkAddComment, bulkUpdateVulns } from 'store/Manage/actions';
import { TableContainer } from './styled';
import VulnsContextMenu from './components/ContextMenu';
import BulkUpdateConfirmationDialog from './components/BulkUpdateConfirmationDialog';
import Table from './components/Table';
import BulkUpdateModal from './components/BulkUpdateModal';
import CreateEditTagsModal from '../VulnerabilityDetail/components/CreateEditTagsModal';
import ExploreGroupHostsTagsModal from './components/ExploreGroupTagsModal/HostsTagsModal';
import ExploreGroupServicesTagsModal from './components/ExploreGroupTagsModal/ServicesTagsModal';
import {
  selectModalBulkUpdateField, selectVulnsTags,
  selectIsFetching, selectModalBulkUpdateValue, selectSelectAll,
  selectVulnsCount, selectVulnsSelected
} from 'store/Manage/selectors';
import { selectShowTagsModal } from 'store/Tags/selectors';
import SelectAll from './components/SelecAll';
import ModalWarning from 'Common/Components/EvidenceTab/components/ModalWarning';
import ReduxModal from 'Common/Components/ReduxModal';
import { selectError, selectErrorMessage } from 'store/ManageEditCreate/selectors';
import ErrorDialog from 'Common/Components/ErrorDialog';
import { resetErrorValue } from 'Screens/Contextualization/ManageEditCreate/actions/Actions';

const ManageTable = () => {
  const dispatch = useDispatch();
  const showTemplateModal = useSelector((state) => selectModal(state, MODAL_APPLY_TEMPLATE));
  const vulnsTags = useSelector(selectVulnsTags);
  const showCreateTagModal = useSelector((state) => selectShowTagsModal('menu', state));
  const showExploreHostsTagModal = useSelector((state) => selectShowTagsModal('exploreGroupHosts', state));
  const showExploreServicesTagModal = useSelector((state) => selectShowTagsModal('exploreGroupServices', state));
  const error = useSelector(selectError);
  const errorMessage = useSelector(selectErrorMessage);
  const vulnsSelected = useSelector(selectVulnsSelected);
  const vulnsCount = useSelector(selectVulnsCount);
  const isSelectAll = useSelector(selectSelectAll);
  const isFetching = useSelector(selectIsFetching);
  const bulkUpdateValue = useSelector(selectModalBulkUpdateValue);
  const bulkUpdateField = useSelector(selectModalBulkUpdateField);

  useEffect(() => {
    dispatch(getWorkspaces(false, true, true));
  }, [dispatch]);

  return (
    <TableContainer>
      <SelectAll />
      {showTemplateModal && <ApplyTemplateModal entity="vulns" vulnsSelected={ vulnsSelected } />}
      <VulnsContextMenu />
      <BulkUpdateModal />
      <BulkUpdateConfirmationDialog
        selected={ vulnsSelected }
        count={ vulnsCount }
        isSelectAll={ isSelectAll }
        isFetching={ isFetching }
        bulkUpdateValue={ bulkUpdateValue }
        bulkUpdateAction={ bulkUpdateVulns }
        bulkUpdateField={ bulkUpdateField }
        bulkAddComment={ bulkAddComment }
        title="Vulnerabilities"
      />
      { showCreateTagModal && <CreateEditTagsModal vulnsTags={ vulnsTags } entity="menu" /> }
      { showExploreHostsTagModal && <ExploreGroupHostsTagsModal /> }
      { showExploreServicesTagModal && <ExploreGroupServicesTagsModal /> }
      <Table />
      <ReduxModal id={ MODAL_EVIDENCE_WARNING_UPLOAD }>
        <ModalWarning />
      </ReduxModal>
      { error ? <ErrorDialog message={ errorMessage } resetError={ () => dispatch(resetErrorValue()) } /> : null }
    </TableContainer>
  );
};

export default ManageTable;
